import instance from '@/api/business' 
import { Product } from '@/types/Product'
import { CreateProduct, DeletProduct, UpdateProduct } from './type'

const BASE_URL = '/product/im/product'

export const fetchProduct = async () => {
    const response = await instance.post<Product[]>(BASE_URL)

    return response.data
}

export const createProduct = async (data: CreateProduct) => {
     const response = await instance.put(BASE_URL, data)
 
     return response.data
}

export const updateProduct = async (data: UpdateProduct) => {
    const response = await instance.patch(BASE_URL, data)

    return response.data
}

export const deleteProduct = async (data: DeletProduct) => {
    const response = await instance.delete(BASE_URL,  {
        data: data,
    })
    
    return response.data 
}